import { WidgetModes, rootId } from 'consts'

const getWidgetMode = () => {
  let widgetMode = WidgetModes.Default
  const container = document.getElementById(rootId)

  if (!container) {
    return widgetMode
  }

  const chatMode = container.dataset?.chatmode as WidgetModes

  if (chatMode && Object.values(WidgetModes).includes(chatMode)) {
    widgetMode = chatMode
  }

  return widgetMode
}

export default getWidgetMode
